import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Empty } from 'antd';
import { GET, POSTFormData, QueryDetail, QueryOrder, pushStateHistoryModal, useAuth, useMetaContext, useNavigation, useTranslateContext, useUserConfigContext, useUserContext, ycStorage } from 'fennec-ui';

import { Action, errorCatch, ModelMobile, POST } from 'fennec-ui';
import { useEffect } from 'react';
import './index.less';
import { useLangSwitchContext } from '../../../components/Context';
import { Avatar, Popup, Dialog, Button, Image } from 'antd-mobile';
import Icofont from 'react-icofont';
import { ExclamationCircleOutlined, LogoutOutlined } from '@ant-design/icons';
import { List } from 'antd-mobile';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import { ycBucket } from '../../../components/Tool';
var _ = require('lodash');

const mainDark = "#001529";

function Sidebar(props) {
	let navigate = useNavigation();
	const auth = useAuth();
	const dispatch = useDispatch();
	const t = useTranslateContext();
	const user = useUserContext();
	const langSwitch = useLangSwitchContext();
	const [userConfig, setUserConfig] = useUserConfigContext();

	const logout = () => {
		auth.logout(() => {
			navigate('/');
		});
	}
	const logoutall = (e) => {
		e.stopPropagation();
		e.preventDefault();

		Dialog.confirm({
			content: t('Вы действительно хотите выйти на всех устройствах?'),
			confirmText: t("Выйти"),
			cancelText: t("Отмена"),
			onConfirm: async () => {
				await auth.logoutall(() => {
					navigate('/');
				});
			},
		})
	}

	return (
		<div className='sidebar'>
			<div>
				{user && <div className='user bg bg-grey dark-5' style={{ padding: "4px" }}>
					<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} />

					<div className='user-name'>
						<div>{user.lastname + " " + user.firstname}</div>
						<div style={{ color: "#9a9a9ab5" }}>{user.email}</div>
					</div>
				</div>}
				<div className='logout bg bg-grey' style={{ padding: "4px", marginTop: "5px" }} onClick={logout}>
					<div>
						<LogoutOutlined />
						<span style={{ paddingLeft: "5px" }}>{t("Выход")}</span>
					</div>
					<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
						<Icofont icon="logout" />
					</div>
				</div>
			</div>
			<div>
				{langSwitch}
			</div>
			<div>
				<List>
					<List.Item
						prefix={<i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i>}
						className={"bg-blue"}>
						<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`}>
							{t("Главный сайт")}
						</a>
					</List.Item>
					<List.Item
						prefix={<Icofont icon="home" style={{ fontSize: "13px", color: "orange" }} />}
						className={"bg-orange"}>
						<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} /*target="_blank" rel="noopener noreferrer"*/ href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`}>
							{t("Личный кабинет")}
						</a>
					</List.Item>
					<List.Item
						prefix={<Icofont icon="ui-calendar" style={{ fontSize: "13px", color: "green" }} />}
						className={"bg-green"}>
						<a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`}>
							{t("Войти в мероприятие")}
						</a>
					</List.Item>
					{/* <List.Item
                        prefix={<Icofont icon="user" style={{ fontSize: "13px" }} />}>
                        <a style={{ fontSize: "14px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`}>
                            {t("Профиль")}
                        </a>
                    </List.Item> */}
				</List>
			</div>
		</div>
	);
}
export default function CommonProfile(props) {
	const auth = useAuth();
	const navigate = useNavigation();
	const dispatch = useDispatch();
	const [userConfig, setUserConfig] = useUserConfigContext();
	const meta = useMetaContext();
	const user = useUserContext();
	const langSwitch = useLangSwitchContext();
	const t = useTranslateContext();

	const vkbot = process.env.REACT_APP_VKBOT
	const tgbot = process.env.REACT_APP_TGBOT

	useEffect(() => {
		auth.fetch('/api/meta').then(res => {
			if (res && res.data && dispatch) {
				dispatch({ type: 'META', payload: res.data })
			}
		});
		auth.fetch('/api/iam').then(res => {
			if (res && res.data) {
				dispatch({ type: 'USER', payload: res.data })
			}
		});
	}, [auth, dispatch]);

	const tgUnlink = () => {
		Dialog.confirm({
			title: t(`Вы уверены что хотите отвязать акканут Федерации от Telegram-чата?`),
			content: "Отвязав аккаунт от чата Вы перестанете получать уведомления Федерации и информацию о Ваших мероприятиях и билетах.",
			confirmText: t("Да, отвязать"),
			cancelText: t("Нет"),
			onConfirm: () => {
				GET(auth, `/api/tg/unlink`, ({ data }) => {
					dispatch({ type: 'USER', payload: data })
				}, errorCatch)
			},
		})
	}
	const vkUnlink = () => {
		Dialog.confirm({
			title: t(`Вы уверены что хотите отвязать акканут Федерации от VK-чата?`),
			content: "Отвязав аккаунт от чата Вы перестанете получать уведомления Федерации и информацию о Ваших мероприятиях и билетах.",
			confirmText: t("Да, отвязать"),
			cancelText: t("Нет"),
			onConfirm: () => {
				GET(auth, `/api/vk/unlink`, ({ data }) => {
					dispatch({ type: 'USER', payload: data })
				}, errorCatch)
			},
		})
	}

	// const [open, setOpen] = useState(false);

	// const onOpenChange = () => {
	// 	setOpen(!open);
	// }

	const stack = [];
	const getStack = React.useCallback(() => {
		return stack;
	}, []);

	const [open, setOpen] = useState(false);
	const menuClose = () => {
		if (open) {
			window.history.back();
		}
	}
	const onOpenChange = () => {
		if (!open) {
			pushStateHistoryModal(setOpen, getStack);
			setOpen(true);
			return
		}
		menuClose();
	}

	return (
		<div className='app'>
			<div className='header' style={{ display: "flex", justifyContent: "space-between", backgroundColor: mainDark }}>
				<NavLink to="/">
					<div style={{ flex: 0 }}>
						<div className="logo-mobile" />
					</div>
				</NavLink>
				<div style={{ flex: 0 }}>
					<div className='sider-button'>
						<Icofont key="1" icon="navigation-menu" onClick={onOpenChange} />
					</div>
				</div>
			</div>
			<div className='content'>
				<Popup
					visible={open}
					// onMaskClick={onOpenChange}
					onMaskClick={menuClose}
					position='right'
					bodyStyle={{ width: '75vw' }}
				>
					<Sidebar />
				</Popup>
				<div className='page'>
					<div style={{ borderRadius: "4px", backgroundColor: "white" }}>
						{user && <div>
							<div style={{ padding: "15px 0px", display: "flex", flexDirection: "column" }}>
								<div style={{ display: "flex", gap: "5px", alignSelf: "center" }}>
									<Action
										auth={auth}
										mode={'func'}
										trigger={(click) => (<div>
											<div style={{ margin: "5px 0px", alignSelf: "center" }} onClick={click}>
												<Image
													width={100}
													height={100}
													style={{ borderRadius: "6px", border: "1px solid #e5e5e5" }}
													src={(user.avatar) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatar : undefined}
												/>
											</div>
										</div>)}
										isFormData={true}
										action={(values, unlock, close, { collection, setCollection }) => {
											POSTFormData(auth, `/api/set-avatar`, values,
												({ data }) => {
													dispatch({ type: 'USER', payload: data })
													close();
												},
												(err) => errorCatch(err, unlock));
										}}
										object={{
											file: (user.avatar) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatar : ""
										}}
										form={ModelMobile}
										meta={[
											{
												name: "file",
												type: "image",
												label: "Аватарка",
											},
										]}
										title="Загрузить фото"
										modal={{
											width: "600px",
											title: "Загрузить фото",
										}}
									/>
								</div>
							</div>
							<div style={{
								margin: "15px", display: "flex", justifyContent: "space-between", flexDirection: "column", gap: "10px",
								backgroundColor: "#f7f7f7",
								padding: "10px",
								alignItems: "center",
								borderRadius: "4px",
								marginBottom: "15px"
							}}>
								<div style={{ flex: "1", fontSize: "18px" }}>
									{user.email}
								</div>
								<div style={{
									display: "flex", justifyContent: "space-between", gap: "10px",
									alignItems: "center",
									width: "100%",
								}}>
									<div style={{ flex: "1" }}>
										<Action
											mode={'func'}
											trigger={(click) => (<Button style={{ width: "100%" }} onClick={click}>Изменить</Button>)}
											title={"Изменить адрес электронной почты"}
											modal={{
												width: "450px",
												title: "Изменить адрес электронной почты",
											}}
											action={(values, unlock, close, { collection, setCollection }) => {
												GET(auth, '/api/email-verification-pincode?pincode=' + values.verifyemail.pincode,
													({ data }) => {
														if (data) {
															dispatch({ type: 'USER', payload: data })
														}
														close();
													}, (err) => errorCatch(err, unlock)
												);
											}}
											steps={[
												{
													key: "emailchange",
													name: "Шаг 1",
													action: (values, unlock, close) => {
														POST(auth, "/api/create-email-verification", values,
															(res) => {
																close();
															}, (err) => errorCatch(err, unlock));
													},
													form: ModelMobile,
													meta: [
														{
															label: "Ноый адрес электронной почты",
															name: "email",
															type: "string",
														},
														{
															label: "Введите действующий пароль",
															name: "password",
															type: "password",
														},
													],
												},
												{
													key: "verifyemail",
													name: "Шаг 2",
													form: ModelMobile,
													meta: [
														{
															type: "func",
															render: (auth, item, value, onChange) => (<div>На указанную Вами электронную почту было отправлено письмо содержащее пинкод для подтвеждения адреса. Ввведите пинкод из электронного письма в поле ниже.</div>)
														},
														{
															label: "Пин-код",
															name: "pincode",
															type: "string",
														}
													],
												}
											]}
										/>
									</div>
									{!user.emailVerification &&
										<div style={{ flex: "1" }}>
											<Action
												mode={'func'}
												trigger={(click) => (<Button style={{ width: "100%" }} onClick={() => {
													POST(auth, "/api/create-email-verification", {},
														(res) => {
															click();
														}, (err) => errorCatch(err));
												}}>Подтвердить</Button>)}

												action={(values, unlock, close, { collection, setCollection }) => {
													GET(auth, '/api/email-verification-pincode?pincode=' + values.pincode,
														({ data }) => {
															if (data) {
																dispatch({ type: 'USER', payload: data })
															}
															close();
														}, (err) => errorCatch(err, unlock)
													);
												}}
												form={ModelMobile}
												meta={[
													{
														type: "func",
														render: (auth, item, value, onChange) => (<div>На указанную Вами электронную почту было отправлено письмо содержащее пинкод для подтвеждения адреса. Ввведите пинкод из электронного письма в поле ниже.</div>)
													},
													{
														label: "Пин-код",
														name: "pincode",
														type: "string",
													}
												]}
												options={{
													initialValues: {},
												}}
												title={"Подтверждение адреса электронной почты"}
												modal={{
													width: "450px",
													title: "Подтверждение адреса электронной почты",
												}}
											/>
										</div>}
								</div>
							</div>
							<div style={{ padding: "10px", margin: "15px" }}>
								<Action
									mode={'func'}
									trigger={(click) => (<Button style={{ width: "100%" }} onClick={click}>Изменить пароль</Button>)}
									action={(values, unlock, close, { collection, setCollection }) => {
										if (!values.newPassword || values.newPassword.length < 8) {
											errorCatch("Пароль должен быть не меньше 8 символов", "error", unlock);
											return;
										}

										if (values.newPassword != values.newPasswordConfirm) {
											errorCatch("Пароли не совпадают", "error", unlock);
											return;
										}

										POST(auth, "/api/change-password", { currentPassword: values.currentPassword, newPassword: values.newPassword },
											({ data }) => {
												dispatch({ type: 'USER', payload: data })
												close();
											}, (err) => errorCatch(err, unlock)
										);
									}}
									object={{ email: user.email }}
									form={ModelMobile}
									meta={[
										{
											label: "Введите действующий пароль",
											name: "currentPassword",
											type: "password",
										},
										{
											label: "Введите новый пароль",
											name: "newPassword",
											type: "password",
										},
										{
											label: "Повторите новый пароль",
											name: "newPasswordConfirm",
											type: "password",
										}
									]}
									options={{
										initialValues: {},
									}}
									title={"Изменить пароль"}
									modal={{
										width: "450px",
										title: "Изменить пароль",
									}}
								/>
							</div>
							<div style={{ paddingBottom: "20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
								<div style={{ display: "flex", gap: "10px" }}>
									<a target="_blank" href={(tgbot) ? 'https://t.me/' + tgbot : "#"}>
										<div className={`bg bg-grey light-10 pointer ${(user && user.tgchatid) ? "border-green" : "border-red"}`} style={{ padding: "5px 10px", display: "flex", gap: "10px", alignItems: "center" }}>
											<div><i className="fa fa-telegram" style={{ fontSize: "22px" }}></i></div>
											<div style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.85)" }}>
												{(user && !user.tgchatid) && <div>Связать аккаунт c Telegram</div>}
												{(user && user.tgchatid) && <div>Ваш аккаунт связан с Telegram</div>}
											</div>
										</div>
									</a>
									{(user && user.tgchatid) && <div onClick={tgUnlink} className={`bg bg-grey light-10 pointer border-red`}><Icofont icon="close" style={{ fontSize: "24px", verticalAlign: "middle" }} /></div>}
								</div>
								<div style={{ display: "flex", gap: "10px" }}>
									<a target="_blank" href={(vkbot) ? 'https://vk.com/im?sel=-' + vkbot : "#"}>
										<div className={`bg bg-grey light-10 pointer ${(user && user.vk) ? "border-green" : "border-red"}`} style={{ padding: "5px 10px", display: "flex", gap: "10px", alignItems: "center" }}>
											<div><i className="fa fa-vk" style={{ fontSize: "22px" }}></i></div>
											<div style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.85)" }}>
												{(user && !user.vk) && <div>Связать аккаунт c VK</div>}
												{(user && user.vk) && <div>Ваш аккаунт связан с VK!</div>}
											</div>
										</div>
									</a>
									{(user && user.vk) && <div onClick={vkUnlink} className={`bg bg-grey light-10 pointer border-red`}><Icofont icon="close" style={{ fontSize: "24px", verticalAlign: "middle" }} /></div>}
								</div>
							</div>
							<Action
								mode={"inline"}
								auth={auth}
								object={user}
								okText="Сохранить"

								action={(values, unlock, close, { collection, setCollection }) => {
									let o = { ...values, ID: user.ID }//, email: values?.email?.replace(/\s/g, '') }
									POST(auth, "/api/update-user", o,
										({ data }) => {
											dispatch({ type: 'USER', payload: data })
											unlock();
										}, (err) => errorCatch(err, unlock)
									);
								}}
								// form={UserUpdate}
								form={ModelMobile}
								meta={[
									{
										label: "Фамилия",
										name: "lastname",
										type: "string",
									},
									{
										label: "Имя",
										name: "firstname",
										type: "string",
									},
									{
										label: "Отчество",
										name: "patronymic",
										type: "string",
									},
									{
										label: "Дата рождения",
										name: "birthday",
										type: "date",
									},
									{
										label: "Город",
										name: "cityID",
										type: "object",
										relation: {
											display: (item) => {
												return item.name
											},
											reference: { object: "City", property: "ID" },
											type: "many-one",
										},
										queryFilter: [
											QueryDetail("model"),
											QueryOrder("name", "ASC")
										]
									},
									{
										label: "Телефон",
										name: "phone",
										type: "string",
									},
									{
										label: "Псевдоним",
										name: "aliase",
										type: "string",
									}
								]}
							/>
						</div>}
						{!user && <Empty
							imageStyle={{
								height: 60,
							}}
							description={
								<span>
									Нет данных
								</span>
							}
							style={{ padding: "100px 0px" }}
						>
						</Empty>}
					</div>
				</div>
			</div>
			<div className={"footer"}>
			</div>
		</div>

	);
}
